import { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AnuncioForm } from "@/components/AnuncioForm";
import { Loader2, Pencil } from "lucide-react";

export default function EditarAnuncio() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [car, setCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/listings/mine").then(({ data }) => setCar(data.find((c) => c.id === id) || false)).finally(() => setLoading(false));
  }, [id]);

  const submit = async (payload) => {
    setSaving(true);
    try {
      await api.put(`/listings/${id}`, payload);
      toast.success("Anúncio atualizado!");
      navigate("/painel");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  const initial = useMemo(() => car ? ({
    marca: car.marca, modelo: car.modelo, versao: car.versao, ano: car.ano, ano_fabricacao: car.ano_fabricacao,
    preco: car.preco, km: car.km, cor: car.cor, cambio: car.cambio, combustivel: car.combustivel,
    cidade: car.cidade, estado: car.estado, blindado: car.blindado, placa: car.placa,
    features: car.features, condicoes: car.condicoes, descricao: car.descricao,
  }) : null, [car]);

  if (loading) return <div className="min-h-[50vh] flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-blaze" /></div>;
  if (!car) return (
    <div className="max-w-4xl mx-auto px-5 py-20 text-center">
      <p className="text-muted-foreground">Anúncio não encontrado.</p>
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10" data-testid="editar-page">
      <span className="overline text-blaze flex items-center gap-1"><Pencil className="w-3 h-3" /> Editar anúncio</span>
      <h1 className="font-heading font-800 text-3xl md:text-4xl mb-8 mt-2">{car.marca} {car.modelo}</h1>
      <AnuncioForm initial={initial} images={car.images || []} onSubmit={submit} saving={saving} submitLabel="Salvar alterações" onCancel={() => navigate("/painel")} />
    </div>
  );
}
